import { useState } from "react"

import { Checkbox, Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import {
  ScriptDeployCommand,
  type ScriptDeployCommandProps
} from "@/pages/DeploymentsPage/components/organisms/ScriptDeployCommand"

import type { AgentPlatformStep } from "./AgentPlatformTab.types"

export interface AgentPlatformStepCommandProps extends Omit<
  ScriptDeployCommandProps<string>,
  "lines" | "groups"
> {
  step: Pick<AgentPlatformStep, "lines" | "groups" | "option">
}

// The script of a platform step; a step option is a checkbox that keeps or
// leaves out its lines
export const AgentPlatformStepCommand = ({
  step: { lines, groups, option },
  ...props
}: AgentPlatformStepCommandProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "deployments" })
  const [included, setIncluded] = useState(!option?.optIn)
  const shownGroups =
    !option || included
      ? groups
      : groups.filter((keys) => !keys.some((key) => option.lines.includes(key)))
  const command = (
    <ScriptDeployCommand lines={lines} groups={shownGroups} {...props} />
  )

  if (!option) return command

  return (
    <Flex vertical gap={8}>
      <Checkbox
        checked={included}
        onChange={({ target }) => setIncluded(target.checked)}
      >
        {t(option.label)}
      </Checkbox>
      <Text type="secondary">{t(option.description)}</Text>
      {command}
    </Flex>
  )
}
